import { styled } from "goober";
import { type ReactNode, type RefObject } from "react";
import { type MentionItem } from "../../hooks/useMentions";
import { ConnectorLogo } from "../ConnectorLogo";
import { CaretMenu } from "./CaretMenu";

const StepBar = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  &::after {
    content: "";
    width: 4px;
    height: 12px;
    border-radius: 2px;
    background: currentColor;
  }
`;

type Props = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  slashStart: number;
  items: readonly MentionItem[];
  selectedIndex: number;
  onSelect: (item: MentionItem) => void;
  footer?: ReactNode;
};

export function MentionMenu({
  textareaRef,
  value,
  slashStart,
  items,
  selectedIndex,
  onSelect,
  footer,
}: Props) {
  const menuItems = items.map((item) => ({
    id: item.id,
    label: item.name,
    section: item.section,
    icon:
      item.kind === "step" ? (
        <StepBar style={{ color: `var(--${item.color}-600)` }} />
      ) : (
        <ConnectorLogo
          template={{ name: item.name, identifier: item.identifier }}
          size={12}
        />
      ),
  }));

  return (
    <CaretMenu
      textareaRef={textareaRef}
      value={value}
      slashStart={slashStart}
      items={menuItems}
      selectedIndex={selectedIndex}
      onSelect={(id) => {
        const item = items.find((i) => i.id === id);
        if (item) onSelect(item);
      }}
      footer={footer}
    />
  );
}
